<template src="../../components/shared/contacts/ViewContactTemplate.html">
</template>

<script>
	import GenericProfileInfo from "./GenericProfileInfo.vue";
	import GenericUserInfo from "./GenericUserInfo.vue";
	import {api} from "../../global/framework/api.js";
	import {common} from "../../global/common.js";	

	export default {
		name: "ViewContactModal",
		components: {GenericUserInfo, GenericProfileInfo},
		data() {
			return {
				widgetReady: false,
				vm: {},
				entityId: 0,
				entityTypeId: 0,
				contactId: 0,
				controllerName: "",
				canEditCredentials: Boolean,
				emailConfirmed: Boolean
			};
		},
		methods: {
			async showModal({entityId, entityTypeId, contactId}) {
				//console.log("Showing contact modal, params: ", arguments);
				this.entityId = entityId;
				this.entityTypeId = entityTypeId;
				this.contactId = contactId;
				this.controllerName = entityTypeId == common.ENTITY_TYPE.COMPANY ? "Company" : "ProviderEntity";				
				await this.init();
			},
			async init() {
				let data = await api.getDataWithTwoIds(this.controllerName, this.entityId, "GetUserInfo", this.contactId);
				this.mapData('vm', data);				
				this.canEditCredentials = await api.getDataWithTwoIds("Shared", this.entityId, "CanEditCredentials",this.vm.contactInfo.userId);  
				this.emailConfirmed = this.vm.userInfo.isEmailConfirmed;								
				this.widgetReady = true;
				this.$refs.modalRef.open();
			},
			closeModal() {
				this.$refs.modalRef.close();
			},
			async save() {
				let result = await api.post(this.controllerName, "SaveUserInfoTab", this.vm);
				if (result) {
					this.$refs.modalRef.close();
					this.$bus.$emit(this.$bus.$AcEvents.CONTACT_CHANGE, result);
				}
			},
			async resetPassword() {
				api.post('Account', 'ForgotPassword', {email: this.vm.contactInfo.emailAddress});
			},
		}
	}
</script>

<style scoped>

</style>